class ClaroluzAlerts {
    public static show(message: string) {
        let element = document.querySelector('.claroluz-alert') as HTMLElement;

        if (element) {
            this.hide();

            element.querySelector('.claroluz-alert-text')!.innerHTML = message;
            element.classList.add('show');

            let height = element.clientHeight + 10;
            document.querySelectorAll('.claroluz-action-box-item').forEach((item: any) => {
                item.style.paddingTop = `${height}px`;
            });
        }
    }

    public static hide() {
        let element = document.querySelector('.claroluz-alert') as HTMLElement;

        if (element && element.classList.contains('show')) {
            element.classList.remove('show');

            document.querySelectorAll('.claroluz-action-box-item').forEach((item: any) => {
                item.style.paddingTop = '';
            });
        }
    }
}

//removeIf(production)
export default ClaroluzAlerts;
//endRemoveIf(production)